import React from "react";
import EmptyState from "../../../Utilities/EmptyState";
import FormLabel from "../../../Utilities/FormLabel";
import ColumnCard from "./ColumnCard";
import TagInput from "../../../Utilities/TagInput";

// ── GlobalColumns ─────────────────────────────────────────────────────────────
// Renders the shared column panel used by:
//   • yes/no mode (restrictToYesNo = true)
//   • fixed table with same-columns mode
//   • dynamic table with fixed columns
const GlobalColumns = ({
  columns,
  restrictToYesNo,
  unitMasters,
  onAddColumn,
  onRemoveColumn,
  onUpdateColumn,
}) => (
  <div className="mb-4">
    <div className="d-flex justify-content-between align-items-center mb-3">
      <FormLabel icon="fas fa-columns">
        {restrictToYesNo ? "Response Options (Columns)" : "Column Headers"}
      </FormLabel>
      <button type="button" className="btn btn-primary btn-sm" onClick={onAddColumn}>
        <i className="fas fa-plus me-1"></i> Add Column
      </button>
    </div>
    <div className="row g-3 mt-2">
      {columns.map((col, colIndex) => (
        <div key={colIndex} className="col-6">
          <ColumnCard
            col={col}
            onLabelChange={(val) => onUpdateColumn(colIndex, "label", val)}
            onTypeChange={(val) => onUpdateColumn(colIndex, "data_type", val)}
            onDelete={() => onRemoveColumn(colIndex)}
            onOptionsChange={(tags) => onUpdateColumn(colIndex, "dropdown_options", tags)}
            showType={!restrictToYesNo}
            unitMasters={unitMasters}
          />
        </div>
      ))}
    </div>
    {columns.length === 0 && <EmptyState message="No columns added yet." />}
  </div>
);

export default GlobalColumns;
